module.exports = __webpack_public_path__ + "img/tag.b890bc41.svg";